import {
  ROOM
} from '../../reduxs'

const initialState = {
  listRoom: [],
  detailRoom: null,
  listBookingOfRoom: null,
  pageCount: ''
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ROOM.actionType.SAVE_LIST_ROOM:
      return {
        ...state, 
        listRoom: action.list
      }

    case ROOM.actionType.SAVE_DETAIL_ROOM:
      return {
        ...state, detailRoom: action.data
      }

    case ROOM.actionType.SAVE_LIST_BOOKING_OF_ROOM:
      return {
        ...state,
        listBookingOfRoom: action.data.list,
        pageCount: action.pageCount
      }

    case ROOM.actionType.CLEAR_ALL_DETAIL_ROOM:
      return initialState

    default:
      return state
  }
}
